// «Ir a arreglar» del PDF de todas (verificador del 2-nov, z48-5): al llegar a un sitio, lo que se ve es su sección, con sus pestañas arriba.
// Con la franja «Sitios del proyecto» abierta, la pestaña Costos quedaba en y=1138 a 375 px con 2 sitios y en y=2324 con 15, y el primer
// texto de viáticos, abajo de todo: el vendedor tocaba «arreglar» y solo veía la misma lista, ya sin el rojo.

/** Cuánto se sigue vigilando: la lista de sitios llega después de pintar y empuja la sección hacia abajo. */
const VIGILAR_MS = 3_000;
const INTERRUPCIONES = ['wheel', 'touchstart', 'pointerdown', 'keydown'] as const;

function aLaSeccion(): void {
  const cuerpo = document.querySelector('.espacio__cuerpo');
  if (!cuerpo) return;
  const barra = document.querySelector<HTMLElement>('.secciones');
  // Las pestañas son pegajosas: el cuerpo tiene que quedar justo debajo de ellas (y ellas, debajo de la cabecera de la app).
  const arriba = barra ? (Number.parseFloat(getComputedStyle(barra).top) || 0) + barra.offsetHeight : 0;
  window.scrollTo({ top: cuerpo.getBoundingClientRect().top + window.scrollY - arriba, behavior: 'instant' });
}

/** Lleva la pantalla a la sección abierta y la mantiene ahí mientras acaba de cargar lo de arriba; el vendedor manda: en cuanto toca, se
 *  deja de mover. Devuelve con qué soltarlo. */
export function mostrarLaSeccion(): () => void {
  aLaSeccion();
  if (typeof ResizeObserver !== 'function') return () => {};
  const vigia = new ResizeObserver(() => aLaSeccion());
  vigia.observe(document.body);
  const soltar = () => {
    vigia.disconnect();
    window.clearTimeout(reloj);
    for (const e of INTERRUPCIONES) window.removeEventListener(e, soltar);
  };
  const reloj = window.setTimeout(soltar, VIGILAR_MS);
  for (const e of INTERRUPCIONES) window.addEventListener(e, soltar, { passive: true });
  return soltar;
}
